export enum Pages {
  home = '/',
  alarms = '/alarms',
  adminPage = '/admin',
  adminUserGroups = '/admin/userGroups',
  agreementLineList = '/agreementLines',
  agreementLineDetails = '/agreementLines/:agreementLineId',

  assetManagementList = '/obe/assetManagement',
  assetManagementDetails = '/obe/assetManagement/:pan2',

  oresundPayData = '/oresundPayData',
  oresundPayDataEdit = '/oresundPayData/edit',

  efcContextData = '/efcContextData',
  efcContextDataInbound = '/efcContextData/inbound',
  efcContextDataOutbound = '/efcContextData/outbound',

  tollChargersList = '/tollChargers',
  tollChargerNew = '/tollChargers/new',
  tollChargerEdit = '/tollChargers/:tollChargerId/edit',
  tollChargerDetails = '/tollChargers/:tollChargerId',
  contractIssuerList = '/contractIssuerList',
  contractIssuerDetails = '/contractIssuerList/:contractIssuerId',

  transactionsList = '/transactions',
  transactionsDetails = '/transactions/:transactionId',

  tollDeclarationsList = '/tollDeclarations',
  tollDeclarations = '/tollDeclarations/:tollDeclarationId',
  billingDetailsList = '/billingDetails',
  billingDetails = '/billingDetails/:billingDetailsId',
  paymentClaimsList = '/paymentClaims',
  paymentClaims = '/paymentClaims/:paymentClaimId',
  paymentAnnouncements = '/paymentAnnouncements',
  abnormalBehaviorReportList = '/abnormalBehaviorReports',
  obeParent = '/obe',
  obeList = '/obe/registry',
  obeDetails = '/obe/registry/:obeEquipmentId',
  obeEventLog = '/obe/eventLog',
  obeKapschEventLog = '/obe/kapschEventLog',
  obeFineHelper = '/obe/fineHelper',
  efcContextMarksList = '/efcContextMarks',
  efcContextMarkNew = '/efcContextMarks/new',
  efcContextMarkEdit = '/efcContextMarks/:efcContextMarkId/edit',
  efcContextMarkDetails = '/efcContextMarks/:efcContextMarkId',
  auditLog = '/auditLog',
  difFiles = '/difFiles',
  exceptionLists = '/exceptionLists',
  exceptionListDetails = '/exceptionLists/:exceptionListId',

  statusAduList = '/statusAdu',
  statusAduListInbound = '/statusAdu/inbound',
}
